
/**
 * @description
 * 로드맵 상세 > 네비게이션
 */

import { DOM_ID_LIST, ROADMAP_NAVIGATOR_ID } from '@/utils/enums.js';
import { mapGetters } from 'vuex';

export default {
  name: 'CourseNavigator',
  data() {
    return {
      viewSection: null,
      descriptionSection: null,
      relatedClassSection: null,
      rafTimeout: false,
    };
  },
  computed: {
    ...mapGetters(['getIsHiddenNavHeader']),
    navClass: ({ viewSection, getIsHiddenNavHeader }) => ({
      'translate-nav':
        viewSection && viewSection !== 'none' && !getIsHiddenNavHeader,
    }),
    navigatorList: ({ clickTab }) => [
      {
        anchorId: ROADMAP_NAVIGATOR_ID.DESCRIPTION,
        textHtml: '로드맵 소개',
        callback: () => clickTab(ROADMAP_NAVIGATOR_ID.DESCRIPTION),
      },
      {
        anchorId: ROADMAP_NAVIGATOR_ID.RELATED_CLASS,
        textHtml: '연결된 수업',
        callback: () => clickTab(ROADMAP_NAVIGATOR_ID.RELATED_CLASS),
      },
    ],
  },
  mounted() {
    this.removeOverflowStyle();

    this.$nextTick(() => {
      document.addEventListener('scroll', this.scrollEventRAF);
    });
  },
  destroyed() {
    this.restoreOverflowStyle();

    document.removeEventListener('scroll', this.scrollEventRAF);
  },
  methods: {
    checkDom() {
      if (!this.descriptionSection)
        this.descriptionSection = document.querySelector(
          `#${ROADMAP_NAVIGATOR_ID.DESCRIPTION}`,
        );
      if (!this.relatedClassSection)
        this.relatedClassSection = document.querySelector(
          `#${ROADMAP_NAVIGATOR_ID.RELATED_CLASS}`,
        );
    },
    removeOverflowStyle() {
      document.body.style.overflowX = 'unset';
    },
    restoreOverflowStyle() {
      document.body.style.overflowX = 'hidden';
    },
    clickTab(sectionId) {
      if (document.querySelector(`#${sectionId}`)) {
        document.documentElement.scrollBy({
          top:
            document.querySelector(`#${sectionId}`).getBoundingClientRect()
              .top -
            document
              .querySelector(`#${DOM_ID_LIST.NAV}`)
              .getBoundingClientRect().height, // 상단 헤더 + tab bar height를 합한 값
          behavior: 'smooth',
        });
      }
    },
    // requestAnimationFrame 화면 프레임 단위로 이벤트를 호출하게 도와줍니다.
    scrollEventRAF() {
      if (!this.rafTimeout) {
        window.requestAnimationFrame(() => {
          this.scrollEvent();
          this.rafTimeout = false;
        });
        this.rafTimeout = true;
      }
    },
    scrollEvent() {
      this.checkDom();

      const nowScrollTop =
        document.documentElement.scrollTop +
        document.querySelector(`#${DOM_ID_LIST.NAV}`).getBoundingClientRect()
          .height +
        1; // 헤더 높이만큼과 1px을 더해 보고있는 섹션 위치를 잡아줍니다.

      const description = this.descriptionSection?.offsetTop;
      const relatedClass = this.relatedClassSection?.offsetTop;

      if (nowScrollTop > relatedClass) {
        this.viewSection = ROADMAP_NAVIGATOR_ID.RELATED_CLASS;
      } else if (nowScrollTop > description) {
        this.viewSection = ROADMAP_NAVIGATOR_ID.DESCRIPTION;
      } else {
        this.viewSection = null;
      }
    },
  },
};
